import { makeStyles } from 'tss-react/mui';

const teceoPrimaryMainRGBA = 'rgba(252, 107, 75, 0.05)';

export const useDefaultAutocompleteOptionsStyles = makeStyles()((theme) => ({
  option: {
    background: theme.palette.background.paper,
    "&[aria-selected='true']": {
      background: teceoPrimaryMainRGBA,
    },
  },
  item: {
    backgroundColor: theme.palette.background.paper,
  },
  selected: {
    backgroundColor: teceoPrimaryMainRGBA,
  },
  hover: {
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  limitedChip: {
    maxWidth: 'calc(100% - 82px)',
  },
}));
